import { Component, HostListener, OnInit } from "@angular/core";
import { BlurUtil } from "../../../common/utils/blurUtil";
import { BaseResponse } from "../../../objects/common/baseResponse";
import { UploadService } from "../../../services/uploadService";

@Component({
    selector: 'customer',
    templateUrl: 'customersImport.component.html',
    moduleId: module.id.toString()
})
export class CustomersImportComponent {
    public idToBlur: string = "customers-import";

    public fileToUpload: File = null;

    public isLoading: boolean;

    public logs: string[] = [];

    constructor(public uploadService: UploadService) {
    }

    @HostListener('window:popstate', ['$event'])
    unBlurMenu(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public handleFileInput(files: FileList) {
        this.fileToUpload = files.item(0);
    }

    public async getSampleFile() {
        this.isLoading = true;
        try{
            const csvData = 
`First name;Last name;Email
John;Doe;john.doe@mail.com
James;Smith;james.smith@mail.com
William;Jones;william.jones@mail.com`;
            var blob = new Blob([csvData], {type: 'text/csv' })
            let url = window.URL.createObjectURL(blob);

            let link = document.createElement('a');

            link.href = url;
            link.download = 'import_customers_sample.csv';

            link.click();
        }
        finally{
            this.isLoading = false;
        }
    }

    public async postFile() {
        this.isLoading = true;
        this.logs = [ "Importing customers..." ];
        const uploadData = new FormData();
        uploadData.append('file', this.fileToUpload, this.fileToUpload.name);
        this.uploadService.uploadCustomers(uploadData)
            .then((res: any) => {
                this.isLoading = false;
                this.logs.push("Customers were successfully imported and email sending is started");
            },
            (res: any) => {
                this.isLoading = false;
                this.logs = [ "Failed to upload the file selected."];
                const response: BaseResponse<any> = res.json();
                this.logs.push(...response.Errors.map(x => x.Value).reduce((a,b)=>a.concat(b),[]));
            });
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/customers-import/customersImport.component.ts